import ApiServiceV2 from '@/helpers/api.service.v2';

const APIV2 = new ApiServiceV2();

export const state = {
    offerKpi: {},
    offerRows: [],
    offerPageInfo: { total: 0 }
};

export const mutations = {
    SET_OFFER_KPI(state, message) {
        state.offerKpi = message || {};
    },
    SET_OFFER_LIST(state, message) {
        state.offerRows = message?.rows || [];
        state.offerPageInfo = message?.pageInfo || { total: 0 };
    }
};

export const actions = {
    // POST /puhunan/offers/kpi -> { totalOffers, offerRatePct, activeLoans, totalDisbursed, avgOfferAmount }
    getPuhunanOffersKPI(context, params) {
        return new Promise((resolve, reject) => {
            APIV2.post('/puhunan/offers/kpi', params)
                .then((response) => {
                    if (response.data.status === 'ok') {
                        context.commit('SET_OFFER_KPI', response.data.message);
                    }
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // POST /puhunan/offers/list -> { rows, pageInfo }
    getPuhunanOffersList(context, params) {
        return new Promise((resolve, reject) => {
            APIV2.post('/puhunan/offers/list', params)
                .then((response) => {
                    if (response.data.status === 'ok') {
                        context.commit('SET_OFFER_LIST', response.data.message);
                    }
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    // POST /puhunan/offers/export -> emails the full filtered set as xlsx
    exportPuhunanOffers(_, params) {
        return new Promise((resolve, reject) => {
            APIV2.post('/puhunan/offers/export', params)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export const getters = {
    offerKpi: (state) => state.offerKpi,
    offerRows: (state) => state.offerRows,
    offerPageInfo: (state) => state.offerPageInfo
};
